var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F21C1C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.104 13.8896C22.104 13.8896 21.6515 19.5021 21.389 21.8663C21.264 22.9955 20.5665 23.6571 19.424 23.678C17.2499 23.7171 15.0732 23.7196 12.8999 23.6738C11.8007 23.6513 11.1149 22.9813 10.9924 21.8721C10.7282 19.4871 10.2782 13.8896 10.2782 13.8896",
    stroke: "#F21C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2568 11.1999H9.12512",
    stroke: "#F21C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5337 11.1995C19.8796 11.1995 19.3162 10.737 19.1879 10.0962L18.9854 9.08283C18.8604 8.61533 18.4371 8.29199 17.9546 8.29199H14.4271C13.9446 8.29199 13.5212 8.61533 13.3962 9.08283L13.1937 10.0962C13.0654 10.737 12.5021 11.1995 11.8479 11.1995",
    stroke: "#F21C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.18cdb9cb45dfb41326e8a04fa1aecd8f.svg";
export { ForwardRef as ReactComponent };